export function getFileNameFromContentDisposition(contentDisposition) {
  if (!contentDisposition) return null
  const filenameUtf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/)
  if (filenameUtf8Match) {
    return decodeURIComponent(filenameUtf8Match[1])
  }
  const filenameMatch = contentDisposition.match(/filename="([^"]+)"/)
  if (filenameMatch) {
    return filenameMatch[1]
  }
  return null
}
